import './Aboutus.css';
let Aboutus=()=>{
    return(
        <div className='aboutus'>
            <div className='subdiv'>
                <div className='subdiv1aboutus subsm'>
                    <img alt='ablutus' src='https://freerangestock.com/sample/141814/office-workers-discussing-in-a-meeting-with-laptops-on-table.jpg'/>
                </div>
                <div className='subdiv2aboutus subsm'> 
                    <p className='description1'>Empowering your Career Journey</p>
                    <br></br>
                    <p className='description1'>With best resume</p>

                </div>
            </div>
            <div className='subdiv'>
                <div className='subdiv2aboutus subsm'> 
                    <p className='description1'>With Our Converter Tools</p>
                    <br></br>
                    <p className='description1'>Like---(Pdf, Images...)</p>

                </div> 
                 <div className='subdiv1aboutus subsm'>
                    <img alt='aboutus' src='https://makeeasyway.in/jobSiteData/uploads/aa.jpg'/>
                </div> 
            </div>          
        </div>
    );
}
export default Aboutus;